// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as SupportAssetsManager from "../../assets/SupportAssetsManager.bs.js";

var infoIcon = SupportAssetsManager.getImage("error-icon.svg");

function SupportErrorBody(Props) {
  return React.createElement("div", {
              className: "error-page-body"
            }, React.createElement("img", {
                  src: infoIcon
                }), React.createElement("p", {
                  className: "supporting-text"
                }, "Something happened from our side"), React.createElement("p", {
                  className: "supporting-text-with-action"
                }, React.createElement("label", {
                      className: "action",
                      onClick: (function (param) {
                          PartnerAppInterface.goBack();
                          
                        })
                    }, "Go back"), " to restart the chat"));
}

var make = SupportErrorBody;

export {
  infoIcon ,
  make ,
  
}
/* infoIcon Not a pure module */
